export const EMAIL_PACOCA = "pacocaredesocial@gmail.com";
export const LINK_DISCORD = "https://discord.gg/wx3PFq52Gv";
export const LINK_WHATSAPP = "https://whatsapp.com/channel/0029VbAuaEiElagrRJCOSy0O";